import { Flex, FlexItem, Spinner, Title } from '@patternfly/react-core';
import PropTypes from 'prop-types';
import React from 'react';
import CompactTelemetryInfo from 'components/CompactTelemetryInfo/CompactTelemetryInfo';

const CompactTelemetryList = ({ telemetryModelValues, isLoading, header = null }) => {

  if (isLoading) {
    return <Spinner size="md"/>;
  }

  return (
    <>
      <Title headingLevel={'h3'}>{ header }</Title>
      <Flex direction={{ default: 'column' }} flexWrap={{ default: 'wrap' }} >
        { telemetryModelValues.map((telemetrySchema, index) => {
          return (
            <FlexItem key={index + telemetrySchema.displayName}>
              <CompactTelemetryInfo telemetrySchema={telemetrySchema} />
            </FlexItem>
          );
        }) }
      </Flex>
    </>
  );
};

CompactTelemetryList.propTypes = {
  telemetryModelValues: PropTypes.arrayOf(CompactTelemetryInfo.propTypes.telemetrySchema),
  isLoading: PropTypes.bool,
  header: PropTypes.string
};

export default CompactTelemetryList;
